// main.jsx (final fix with correct delete route usage and matching backend endpoint)

import { useState, useEffect } from "react";
import PromptTemplates from "./PromptTemplates";
import UploadForm from "./UploadForm";
import LogsTable from "./LogsTable";
import LogModal from "./LogModal";
import SummaryDisplay from "./SummaryDisplay";
import {
  fetchSavedPrompts,
  savePromptTemplate,
  deletePromptTemplate,
  fetchLogs,
  runValidatorAnalysis,
} from "../../core/api/validator"; 
import { getProfileTest } from "../../core/api/auth";

function Validator() {
  const [label, setLabel] = useState("");
  const [prompt, setPrompt] = useState("");
  const [templateName, setTemplateName] = useState("");
  const [files, setFiles] = useState([]);
  const [savedPrompts, setSavedPrompts] = useState({});
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [finalSummary, setFinalSummary] = useState("");
  const [finalFilePath, setFinalFilePath] = useState("");
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [tokensUsed, setTokensUsed] = useState(0);
  const [logs, setLogs] = useState([]);
  const [activeLog, setActiveLog] = useState(null);
    

  useEffect(() => {
    loadSavedPrompts();
    loadLogs();
  }, []);

  const handleFileChange = (e) => {
    if (e.target.files) setFiles(Array.from(e.target.files));
  };

  const loadSavedPrompts = async () => {
    try {
      const data = await fetchSavedPrompts();
      const promptsMap = {};
      data?.forEach((item) => {
        promptsMap[item.name] = item.prompt;
      });
      setSavedPrompts(promptsMap);
    } catch (error) {
      console.error("Error loading prompts:", error);
    }
  };

  const loadLogs = async () => {
    try {
      const data = await fetchLogs();
      setLogs(data);
    } catch (error) {
      console.error("Error loading logs:", error);
    }
  };

  const savePrompt = async () => {
    try {
      await savePromptTemplate({ name: templateName, prompt });
      loadSavedPrompts();
    } catch (error) {
      console.error("Error saving prompt:", error);
    }
  };

  const runAnalysis = async () => {
    setLoading(true);
    setProgress(0);

    const formData = new FormData();
    formData.append("label", label);
    formData.append("prompt_name", selectedTemplate.toLowerCase());
    formData.append("prompt", prompt);
    files.forEach((file) => formData.append("files", file));
    try {
      const data = await runValidatorAnalysis(formData);
      setFinalSummary(data.final_summary || data.result);
      setFinalFilePath(data.final_file_path || "");
      setTokensUsed(data.tokens_used);
      loadLogs();
    } catch (error) {
      console.error("Error during analysis:", error);
    } finally {
      setLoading(false);
    }
  };
      
      
      

  return (
    <div className="">
      <div className="p-5">
        <h1 className="text-center mb-4">ValidatorAI</h1>

        <UploadForm
          label={label}
          setLabel={setLabel}
          prompt={prompt}
          setPrompt={setPrompt}
          templateName={templateName}
          setTemplateName={setTemplateName}
          files={files}
          handleFileChange={handleFileChange}
          savePrompt={savePrompt}
          runAnalysis={runAnalysis}
          loading={loading}
          progress={progress}
        />

        <PromptTemplates
          savedPrompts={savedPrompts}
          selectedTemplate={selectedTemplate}
          setSelectedTemplate={setSelectedTemplate}
          setPrompt={setPrompt}
          deletePrompt={(name) => {
            deletePromptTemplate({ name })
              .then(loadSavedPrompts)
              .catch((err) => console.error("Delete error:", err));
          }}
        />

        <SummaryDisplay
          finalSummary={finalSummary}
          finalFilePath={finalFilePath}
          tokensUsed={tokensUsed}
        />

        <LogsTable logs={logs} setActiveLog={setActiveLog} />

        {activeLog && (
          <LogModal activeLog={activeLog} setActiveLog={setActiveLog} />
        )}
      </div>
    </div>
  );
}

export default Validator;
